import React, { useEffect, useState } from "react";
import RadioList from "../util/RadioList";
import { GetFilters } from "../util/Api";
import * as analytics from "../util/Analytics/FilterAnalytics";
const SideFilters = ({
    card,
    handleSideFilterSelection,
    topFilterSelection,
    sideFilterParameters,
    onResetSideFilterParameters,
    sideFilterYearRef
}) => {
    const [year, setYear] = useState([]);
    const [stratificationCategoryId, setStratificationCategoryId] = useState([]);
    const [dataValueTypeId, setDataValueTypeId] = useState([]);
    const [sideFilterData, setSideFilterData] = useState(null);

    useEffect(() => {
fetchSideFilterData();
    }, [topFilterSelection, card]);

    const selectedDataValueType =
        sideFilterData && sideFilterData.DataValueTypes
            ? sideFilterData.DataValueTypes.filter(function (item) {
                return item.DataValueTypeId === dataValueTypeId;
            })
            : null;

    const selectedYear =
        sideFilterData && sideFilterData.Years
            ? sideFilterData.Years.filter(function (item) {
                return item.YearId === year;
            })
            : null;

    const showAllYearsRadioButton =
        topFilterSelection &&
            topFilterSelection.location &&
            topFilterSelection.location.LocationAbbr &&
            topFilterSelection.location.LocationAbbr !== "ALL"
            ? true
            : false;

    const filterSelection = {
        Year: selectedYear && selectedYear.length > 0 ? selectedYear[0].Year : "All Available Years",
        YearId:
            year === "ALLYEARS" && !showAllYearsRadioButton
                ? sideFilterData.Years[0].YearId
                : year,
        StratificationCategoryId: stratificationCategoryId,
        DataValueTypeId: dataValueTypeId,
        DataValueType:
            selectedDataValueType && selectedDataValueType.length > 0
                ? selectedDataValueType[0].DataValueType
                : "",
    };


    async function fetchSideFilterData() {
        try {
            const sideFilterDataResponse = await GetFilters(
                topFilterSelection.topic.TopicId,
                topFilterSelection.location.LocationAbbr,
                card.QuestionId
            );

            //sets values filter data
            setSideFilterData(sideFilterDataResponse.data);

            


            if (sideFilterParameters && (sideFilterParameters.dataValueTypeIdParameter || sideFilterParameters.stratificationCategoryIdParameter || sideFilterParameters.yearIdParameter)) {


                const defaultYearId = sideFilterParameters.yearIdParameter;
                const defaultYear = sideFilterDataResponse.data.Years.filter(x => x.YearId === defaultYearId)[0].Year;
                const defaultStratificationCategoryId = sideFilterParameters.stratificationCategoryIdParameter;
                const defaultDataValueTypeId = sideFilterParameters.dataValueTypeIdParameter;
                //const defaultDataValueType =                    sideFilterDataResponse.data.DataValueTypes[0].DataValueType;

                handleYearChange(defaultYearId);
                handleStratificationCategoryChange(defaultStratificationCategoryId);
                handleDataValueTypesChange(defaultDataValueTypeId);

                const defaultDataValueTypeObj =
                    sideFilterDataResponse.data.DataValueTypes.filter(x => x.DataValueTypeId === sideFilterParameters.dataValueTypeIdParameter);


                const defaultDataValueTYpe = defaultDataValueTypeObj[0].DataValueType
                //build default values to pass to parent
                const defaultFilterSelections = {
                    Year: defaultYear,
                    YearId: defaultYearId,
                    StratificationCategoryId: defaultStratificationCategoryId,
                    DataValueTypeId: defaultDataValueTypeId,
                    DataValueType: defaultDataValueTYpe,
                };

                onResetSideFilterParameters();

                //sets default values for the filter selection dom elmenets (years, data value type, view by)
                handleSideFilterSelection(defaultFilterSelections);
            } else {
                //get the defaults
                const defaultYearId = sideFilterParameters && sideFilterParameters.viewtrends === "GO" ? "ALLYEARS" : sideFilterDataResponse.data.Years[0].YearId;
                const defaultYear = sideFilterParameters && sideFilterParameters.viewtrends === "GO" ? "All Available Years" : sideFilterDataResponse.data.Years[0].Year;
                const defaultStratificationCategoryId =
                    sideFilterDataResponse.data.StratificationCategories[0]
                        .StratificationCategoryId;
                const defaultDataValueTypeId =
                    sideFilterDataResponse.data.DataValueTypes[0].DataValueTypeId;
                const defaultDataValueType =
                    sideFilterDataResponse.data.DataValueTypes[0].DataValueType;

                handleYearChange(defaultYearId);
                handleStratificationCategoryChange(
                    sideFilterDataResponse.data.StratificationCategories[0]
                        .StratificationCategoryId
                );
                handleDataValueTypesChange(
                    sideFilterDataResponse.data.DataValueTypes[0].DataValueTypeId
                );

                //build default values to pass to parent
                const defaultFilterSelections = {
                    Year: defaultYear,
                    YearId: defaultYearId,
                    StratificationCategoryId: defaultStratificationCategoryId,
                    DataValueTypeId: defaultDataValueTypeId,
                    DataValueType: defaultDataValueType,
                };

                onResetSideFilterParameters();

                //sets default values for the filter selection dom elmenets (years, data value type, view by)
                handleSideFilterSelection(defaultFilterSelections);
            }


            //set the state

        } catch (error) {
            console.log(error);
        }
    }

    function handleSubmit() {

        analytics.selectYear({ Years: filterSelection.YearId })
        analytics.selectViewBy({ ViewBy: filterSelection.StratificationCategoryId })
        analytics.selectDataType({ DataValueTypeId: filterSelection.DataValueTypeId })

        handleSideFilterSelection(filterSelection);
    }

    function handleYearChange(year) {
        setYear(year);
    }
    function handleStratificationCategoryChange(StratificationCategoryId) {
        setStratificationCategoryId(StratificationCategoryId);
    }
    function handleDataValueTypesChange(DataValueTypeId) {
        setDataValueTypeId(DataValueTypeId);
    }
    const invalidCombo = [{
        message: 'Age adjusted is not applicable for View By Age, please make a different selection.',
        values: ['AGE', 'AGEADJPREV', 'AGEADJRATE','AGEADJMEAN']
    }]

    let errors = [];
    invalidCombo.forEach((item, index) => {
        let errorCount = 0;

        if (item.values.includes(year)) errorCount += 1;
        if (item.values.includes(stratificationCategoryId)) errorCount += 1;
        if (item.values.includes(dataValueTypeId)) errorCount += 1;

        if (errorCount > 1) errors.push(item.message);
    });

    
    const SideFilterComboErrors = ({ data, indicator }) => {


        return (
            errors.map((error, i) => (
                <div className="error-list"  >{error}</div>
            ))

        )
    };

    return (
        <div className="order-2 col-xs-4 col-sm-4 col-md-3 col-lg-3 d-print-none ">
            {sideFilterData ? (
                <div className="sideFilter-container">
                    <>
                        <div className="sideFilter" ref={sideFilterYearRef}>
                            <RadioList
                                filterOptions={sideFilterData.Years}
                                filterDataName="Year"
                                filterDataValue="YearId"
                                filterTitle="Year"
                                filtername="year"
                                questionId={card.QuestionId}
                                onChange={handleYearChange}
                                value={year}
                                selectAll={showAllYearsRadioButton}
                                selectAllTitle={"All Available Years (Trendline)"}
                                selectAllValue="ALLYEARS"
                                enableSeeMore={true}
                                seeLessMaxCount={5}
                            />
                        </div>

                        <div className="sideFilter">
                            <div className="sideFilter-border"></div>
                            <RadioList
                                filterOptions={sideFilterData.StratificationCategories}
                                filterDataName="StratificationCategory"
                                filterDataValue="StratificationCategoryId"
                                filterTitle="View By"
                                filtername="viewBy"
                                questionId={card.QuestionId}
                                onChange={handleStratificationCategoryChange}
                                value={stratificationCategoryId}
                                enableSeeMore={true}
                                seeLessMaxCount={5}
                            />
                        </div>
                        <div className="sideFilter">
                            <div className="sideFilter-border"></div>
                            <RadioList
                                filterOptions={sideFilterData.DataValueTypes}
                                filterDataName="DataValueType"
                                filterDataValue="DataValueTypeId"
                                filterTitle="Data Type"
                                filtername="dataType"
                                questionId={card.QuestionId}
                                onChange={handleDataValueTypesChange}
                                value={dataValueTypeId}
                                enableSeeMore={true}
                                seeLessMaxCount={5}
                            />
                        </div>
                        <div className="text-left text-sm-center ">
                            <button
                                className="filter-data-button btn btn-cdc-blue buttonMinWidth mb-2"
                                onClick={handleSubmit}
                                disabled={errors.length > 0 ? true : false}
                            >
                                Update
                            </button>
                            <SideFilterComboErrors></SideFilterComboErrors>
                            <span id="filterDataLoading" className="hidden">
                                &nbsp;Loading...
                            </span>
                        </div>
                    </>
                </div>
            ) : (
                "Loading filters..."
            )}
        </div>
    );
};

export default SideFilters;
